import { IMetricDefinition } from '../../types';

export const Clicks: IMetricDefinition = {
  metric: 'PerformanceMetrics\\Clicks',
  titleKey: 'ColumnName_Clicks',
};

export const Impressions: IMetricDefinition = {
  metric: 'PerformanceMetrics\\Impressions',
  titleKey: 'ColumnName_Impressions',
};

export const CTR: IMetricDefinition = {
  metric: 'PerformanceMetrics\\CTR',
  titleKey: 'ColumnName_ClickThruRate',
};

export const AverageCPC: IMetricDefinition = {
  metric: 'PerformanceMetrics\\AverageCPC',
  titleKey: 'ColumnName_CPC',
};

export const AverageCPM: IMetricDefinition = {
  metric: 'PerformanceMetrics\\AverageCPM',
  titleKey: 'ColumnName_CostPerImpression',
};

export const Spend: IMetricDefinition = {
  metric: 'PerformanceMetrics\\Spend',
  titleKey: 'ColumnName_Spend',
};

export const TotalSpend: IMetricDefinition = {
  metric: 'PhonePerformanceMetrics\\ClickAndPhoneSpend',
  titleKey: 'ColumnName_TotalCost',
};
